<template>
  <div style="height: 100%; color: #FAFAFA;">
    <label style="padding: 20px 0px 10px 30px;">蓄电池</label>
    <div v-if="deviceDataList.length > 0" style="height: 85%">
      <!-- 2个及以下设备直接显示 -->
      <template v-if="pageList.length === 1">
        <el-row style="height: 100%;">
          <el-col :span="12" v-for="device in pageList[0]" :key="device.deviceName" class="text-center">
            <el-row>
              <label :style="{ lineHeight: '3vh', color: (device.status !== undefined && device.status !== 0) ? '#ff0000' : '#fff' }">
                {{ device.deviceName }}
              </label>
            </el-row>
            <el-row style="margin-top: 1vh;">
              <el-col :span="10" class="text-right text-blueGrey">总电压：</el-col>
              <el-col :span="6" class="text-left" style="margin-left: 10px;">{{ device.voltage }}V</el-col>
            </el-row>
            <el-row style="margin-top: 1vh;">
              <el-col :span="10" class="text-right text-blueGrey">平均温度：</el-col>
              <el-col :span="6" class="text-left" style="margin-left: 10px;">{{ device.temperature }}℃</el-col>
            </el-row>
            <el-row style="margin-top: 1vh;">
              <el-col :span="10" class="text-right text-blueGrey">电流：</el-col>
              <el-col :span="6" class="text-left" style="margin-left: 10px;">{{ device.current }}A</el-col>
            </el-row>
          </el-col>
        </el-row>
      </template>
      <!-- 超过2个设备使用轮播 -->
      <template v-else>
        <el-carousel 
          :interval="10000" 
          indicator-position="none" 
          :autoplay="true" 
          style="height: 100%; z-index: 0">
           <el-carousel-item v-for="(page, index) in pageList" :key="index">
            <el-row style="height: 100%;">
              <el-col :span="12" v-for="device in page" :key="device.deviceName" class="text-center">
                 <el-row>
                  <label :style="{ lineHeight: '3vh', color: (device.status !== undefined && device.status !== 0) ? '#ff0000' : '#fff' }">
                    {{ device.deviceName }}
                  </label>
                </el-row>
                <el-row style="margin-top: 1vh;">
                  <el-col :span="10" class="text-right text-blueGrey">总电压：</el-col>
                  <el-col :span="6" class="text-left" style="margin-left: 10px;">{{ device.voltage }}V</el-col>
                </el-row>
                <el-row style="margin-top: 1vh;">
                  <el-col :span="10" class="text-right text-blueGrey">平均温度：</el-col>
                  <el-col :span="6" class="text-left" style="margin-left: 10px;">{{ device.temperature }}℃</el-col>
                </el-row>
                <el-row style="margin-top: 1vh;">
                  <el-col :span="10" class="text-right text-blueGrey">电流：</el-col>
                  <el-col :span="6" class="text-left" style="margin-left: 10px;">{{ device.current }}A</el-col>
                </el-row>
              </el-col>
            </el-row>
          </el-carousel-item>
        </el-carousel>
      </template>
    </div>
    <div v-else style="height: 100%; padding-top: 20%">
      <no-data></no-data>
    </div>
  </div>
</template>

<script>
import NoData from "@/components/NoData";
import { getSpecialTypeValues } from "@/network/measuring-point-history";

export default {
  name: "controlRoomBattery",
  components: { NoData },
  data() {
    return {
      deviceDataList: [],
      pageList: [],
      pageSize: 2, 
      deviceType: 'PM_BMU', 
      // Using batv for voltage as batavgt implies average temperature. 
      // If user insists on batavgt for voltage, they can change it, but this is the logical correction.
      pointCodes: 'batsumv,batavgt,bati' 
    };
  },
  mounted() {
    this.getData();
  },
  created() {
    this.$store.dispatch('addIntervalObj', { 'getBatteryData:10000': this.getData })
  },
  destroyed() {
    this.$store.dispatch('removeIntervalObj', 'getBatteryData')
  },
  methods: {
    getData() {
      getSpecialTypeValues(this.deviceType, this.pointCodes).then(res => {
        if (res.code === 0 && res.data) {
          const { devices, devicePointValues } = res.data;
          if (devices && devices.length > 0) {
            this.deviceDataList = this.processData(devices, devicePointValues);
            if (this.deviceDataList.length > 0) {
              this.pageList = this.chunkData(this.deviceDataList, this.pageSize);
            } else {
              this.pageList = [];
            }
          } else {
            this.deviceDataList = [];
            this.pageList = [];
          }
        } else {
          this.deviceDataList = [];
          this.pageList = [];
        }
      }).catch(() => {
        this.deviceDataList = [];
        this.pageList = [];
      });
    },
    processData(devices, devicePointValues) {
      const result = [];
      for (let i = 0; i < devices.length; i++) {
        const device = devices[i];
        const values = devicePointValues[i];
        if (device && values) {
          result.push({
            deviceName: device.name || '未知设备',
            status: device.status,
            voltage: values[0] != null ? values[0] : '--',
            temperature: values[1] != null ? values[1] : '--',
            current: values[2] != null ? values[2] : '--'
          });
        }
      }
      return result;
    },
    chunkData(data, size) {
      const result = [];
      for (let i = 0; i < data.length; i += size) {
        result.push(data.slice(i, i + size));
      }
      return result;
    }
  }
}
</script>

<style scoped>
label {
  font-weight: bold;
  color: #01EFFD;
}
</style>
